/* eslint-disable import/prefer-default-export */
/**
 * Formats a PascalCase or camelCase string into a human-readable title with spaces.
 * @param text - The text to format
 * @returns Formatted text with spaces before capital letters
 * @example
 * formatTitle("InternationalCode") // "International Code"
 * formatTitle("customerName") // "Customer Name"
 */
export const formatTitle = (text: string): string => {
  if (!text) {
    return "";
  }
  return text
    .trim()
    .replaceAll(/([A-Z])/g, " $1")
    .replaceAll(/\s+/g, " ")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};
